'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/popover/style/css.js
// module id = BOa/
// module chunks = 0